export const isMobile = (): boolean => {
  const userAgent = navigator.userAgent;
  const isMobileUA =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      userAgent,
    );
  const isIPadSafari =
    /Macintosh/.test(userAgent) && navigator.maxTouchPoints > 1;

  return isMobileUA || isIPadSafari;
};
